import { NgIf } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FileUploadComponent } from '../file-upload/file-upload.component';

/** app-file-upload in a dialog with an Upload button. Projected content (existing attachments) sits above the picker. */
@Component({
    selector: 'app-file-upload-dialog',
    templateUrl: './file-upload-dialog.component.html',
    standalone: true,
    imports: [NgIf, FileUploadComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadDialogComponent implements OnChanges {
    @Input() open = false;
    @Input() heading = 'Upload files';
    @Input() icon = 'paperclip';
    @Input() accept: string | null = null;
    @Input() multiple = false;
    @Input() maxBytes: number | null = null;
    @Input() maxFiles: number | null = null;
    @Input() hint: string | null = null;
    @Input() saveLabel: string | null = null;
    @Input() saving = false;
    @Input() saveError: string | null = null;

    @Output() save = new EventEmitter<File[]>();
    @Output() closed = new EventEmitter<void>();

    files: File[] = [];

    get buttonLabel(): string {
        if (this.saveLabel) {
            return this.saveLabel;
        }
        return this.files.length > 1 ? `Upload ${this.files.length} files` : 'Upload';
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['open'] && !this.open) {
            this.files = [];
        }
    }

    submit(): void {
        if (this.files.length && !this.saving) {
            this.save.emit([...this.files]);
        }
    }

    close(): void {
        if (!this.saving) {
            this.closed.emit();
        }
    }
}
